(function () {
    angular.module('emarket.main.profile').factory('ChatDialog', ['$log', '$mdDialog', 'Chat', function ($log, $mdDialog, Chat) {
        var dialog = {};
        dialog.show = function (ev, userId) {
            var chat = Chat.$build({
                userId: userId
            });
            var promise = chat.$save()
                .$asPromise()
                .then(function (chat) {
                    chat.participants.reverse();                    
                    return $mdDialog.show({
                        controller: 'ChatDetailController as model',
                        templateUrl: 'main/profile/chat/dialog/chat-dialog.tpl.html',
                        clickOutsideToClose: true,
                        locals: {
                            $stateParams: {
                                chat: chat,
                                isDialog : true
                            }
                        },
                        targetEvent: ev
                    });
                });

            return promise;
        };
        return dialog;
    }]);

}());
